import { useEffect, useRef } from 'react';

interface UseNavigateOnExtractionStartParams {
  /** Extraction lifecycle status from useRateActionExtract. */
  status: string;
  /** Request ID created by the in-flight extraction (null until the mutation has produced one). */
  requestId: string | null;
  /** Called once per requestId, the moment polling begins, to sync the URL for refresh-resume. */
  onStart: (requestId: string) => void;
}

/**
 * Fires `onStart(requestId)` exactly once per requestId, at the moment the extraction
 * transitions into the polling phase. Used to push the new requestId into the URL so a
 * refresh during extraction lands the user back on the same in-flight letter.
 */
export function useNavigateOnExtractionStart({
  status,
  requestId,
  onStart,
}: UseNavigateOnExtractionStartParams) {
  const firedForRef = useRef<string | null>(null);
  useEffect(() => {
    if (status !== 'polling' || !requestId) return;
    if (firedForRef.current === requestId) return;
    firedForRef.current = requestId;
    onStart(requestId);
  }, [status, requestId, onStart]);
}
